import { render, staticRenderFns } from "./MomentumConservationViz.vue?vue&type=template&id=8188ddbe&scoped=true"
import script from "./MomentumConservationViz.vue?vue&type=script&lang=js"
export * from "./MomentumConservationViz.vue?vue&type=script&lang=js"
import style0 from "./MomentumConservationViz.vue?vue&type=style&index=0&id=8188ddbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8188ddbe",
  null
  
)

export default component.exports